import PropTypes from 'prop-types'

import styled from '@emotion/styled'

import { ReactComponent as LensIcon } from '../../../images/svg/lens_emptyState.svg'
import Icon from '../../ui/Icon'

const StyledRoot = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '32px',
})

const StyledIcon = styled.div(({ theme }) => ({
  width: '160px',
  height: '160px',
  marginBottom: theme.spaces.default * 1.5,
}))

const BaseTypography = styled.p(({ theme: { spaces } }) => ({
  textAlign: 'center',
  margin: 0,
  lineHeight: `${spaces.default * 1.5625}px`,
}))

const Title = styled(BaseTypography)(({ theme }) => ({
  fontSize: theme.spaces.default * 1.0625,
  fontWeight: '800',
}))

const Body = styled(BaseTypography)(({ theme }) => ({
  fontSize: theme.spaces.default * 0.875,
  fontWeight: '600',
  [`@media (min-width: ${theme.breakpoints.small})`]: {
    width: '50%',
  },
  [`@media (min-width: ${theme.breakpoints.xlarge})`]: {
    width: '25%',
  },
}))

const SearchEmptyState = ({
  title,
  description,
}) => (
  <StyledRoot data-test="SearchEmptyState">
    <StyledIcon>
      <Icon>
        <LensIcon />
      </Icon>
    </StyledIcon>
    <Title>
      {title}
    </Title>
    <Body>
      {description}
    </Body>
  </StyledRoot>
)

SearchEmptyState.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
}

SearchEmptyState.defaultProps = {
  title: '',
  description: '',
}

SearchEmptyState.displayName = 'SearchEmptyState'
SearchEmptyState.whyDidYouRender = true

export default SearchEmptyState
